export const environmentData = {
  run: "development",
  development: {
    clientId: "68df184b-aad8-48d1-8d3d-f55506c40b4f",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 68df184b-aad8-48d1-8d3d-f55506c40b4f/user_scope1",

    apiBaseURL: "https://hm-alshaya-api2.azurewebsites.net/api",
  },
  staging: {
    clientId: "68df184b-aad8-48d1-8d3d-f55506c40b4f",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 68df184b-aad8-48d1-8d3d-f55506c40b4f/user_scope1",

    apiBaseURL: "https://hm-alshaya-api2.azurewebsites.net/api",
  },
  production: {
    clientId: "68df184b-aad8-48d1-8d3d-f55506c40b4f",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8/oauth2/v2.0/token",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 68df184b-aad8-48d1-8d3d-f55506c40b4f/user_scope1",
    apiBaseURL: "https://hm-alshaya-api2.azurewebsites.net/api",
  },
};
